module.exports = "/_next/static/images/organization2-d210fbc59cd62cb745cd8381ef187ab7.jpg";